import {$} from './jquery-definition.js';
import 'is-in-viewport';

$( function() {
	animateInViewport();

	$( '.loader' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		disableLoader();
	} );

	setTimeout( function() {
		disableLoader();
	}, 500 );
} );

function disableLoader() {
	var $loader = $( '.loader' );

	$loader.addClass( 'opacity-0' ).addClass( 'pointer-events-none' );
	$( 'body' ).removeClass( 'overflow-y-hidden' );
}

$( window ).scroll( function() {
	setTimeout( function() {
		animateInViewport();
	}, 100 );
} );

export function animateInViewport() {
	$( '.move-up-in-viewport, .move-down-in-viewport, .move-left-in-viewport, .move-right-in-viewport, .fade-in-in-viewport, .zoom-in-in-viewport, .active-in-viewport' ).each( function() {
		var $this = $( this );

		if ( !$this.parents( '.custom-activation' ).length ) {
			if ( $this.is( ':in-viewport' ) ) {
				$this.addClass( 'active' );
			}
		}
	} );
}
